module.exports = __webpack_public_path__ + "img/alarm-device.9dcf67b0.png";